// extracted by mini-css-extract-plugin
export default {"radio_group":"RadioGroup_radio_group__Jtgzc","radio_box":"RadioGroup_radio_box__mHTT-","radio_text":"RadioGroup_radio_text__M5QIb"};